import NumberHelper from '../../../helpers/NumberHelper';
import { GridColumnCommonOptionsType } from '../enums';

const FIRST_COLUMN_LEFT_POSITION = 0;

const GridStickyColumns = {
  data() {
    return {
      stickyPositions: [],
    };
  },
  methods: {
    calculateColumnsLeftPositions(columns, refs) {
      this.stickyPositions = columns.reduce((acc, column, index) => {
        const element = refs[column.key];
        const width = element.offsetWidth;
        const isSticky = column.options?.[GridColumnCommonOptionsType.IsSticky];

        return [...acc, isSticky ? NumberHelper.getSum(acc[index], width) : acc[index]];
      }, [FIRST_COLUMN_LEFT_POSITION]);
    },
  },
};

export default GridStickyColumns;
